import React, {Component} from 'react';
import {connect} from 'react-redux'
import {bindActionCreators} from 'redux'
import {BrowserRouter as Router, Route,Link} from 'react-router-dom'
import {Container,Row, Col,CardImg} from 'reactstrap';
import Header from '../Header/'
import Footer from '../Footer/'
import {CmsPage} from '../../components/cms/'
import {SingIn, UserPage, Registration,Forgotpassword,ChangePassword} from '../User/'
import Eventslimit from '../../components/events/Eventslimit'
import {EventsPage} from '../../components/events/'
import EventsSearch from '../../components/events/EventsSearch'
import EventDownloadUser from '../../components/events/EventDownloadUser'
import Addresse from '../../components/Addresse'
import * as generalActions from '../../actions/generalActions'
import {requestLogin} from '../../actions/userActions'
import '@fortawesome/fontawesome-free/css/all.min.css';
import AOS from 'aos';
import 'aos/dist/aos.css';



class Page extends Component {

  componentWillMount() {
    AOS.init();
    let {generalActions, requestLogin} = this.props

    generalActions.getActiveCurrency();
    requestLogin();
    
  }

  componentDidUpdate() {
    AOS.refresh();
  }
   
  
  render() {
   
    return (
      <Router>
        <main className="d-flex flex-column">
          <Header />
          <Route exact path="/" render={() => (
              <div className="flex-grow-1 content">
                <Container fluid={true} className="bg-img p-0">
                  <Container className="flex-grow-1">
                      <Row>
                        <Col xs="12" md="6" lg="6" className="section1" data-aos="fade-right">
                            <h1><span>1</span>Data Hexagone</h1>
                            <h2>La formation en big data et informatique</h2>
                            <i>Data analyst, base de donnée …</i>
                            <div className="mt-5">
                                    <Link className="phone" to={`#`}><i className="fas fa-phone"></i>&nbsp;&nbsp; 01 83 64 17 94</Link>
                                    <Link className="decouvrir" to={`#`}>Découvrir &nbsp;&nbsp;<i className="fas fa-arrow-right"></i></Link>
                            </div>
                        </Col>
                        <Col xs="12" md="6" lg="6" data-aos="fade-left" className="column-image">
                            <CardImg src="/images/logo/photo-info-min.png" alt="zone"/>
                        </Col>
                      </Row>

                  </Container>
                </Container>
                <Container fluid={true} className="bg-pencil p-0">
                  <Container className="flex-grow-1">
                      <Row className="mt-3">
                        <Col xs="12" md="2" lg="2">
                            <CardImg src="/images/logo/search.png" alt="zone"/>
                        </Col>
                        <Col xs="12" md="10" lg="10">
                            <h2 className="title-search mb-4 mt-4"  data-aos="fade-up">Rechercher une formation</h2>
                            <EventsSearch />
                        </Col>
                      </Row>

                  </Container>
                </Container>
                <Container className="flex-grow-1">
                  <h2 className="title3 mb-5 mt-5"  data-aos="fade-up">Nos meilleures formations</h2>
                  <div data-aos="zoom-in">
                       <Eventslimit />
                  </div>

                </Container>
                <Container className="flex-grow-1 zone">
                  <Row className="mt-5">
                    <Col xs="12" md="6" lg="6">
                        <h2 className="title3 mb-5"  data-aos="fade-up">Nos centres de formations</h2>
                        <CardImg src="/images/logo/zone.png" alt="zone"/>
                    </Col>
                    <Col xs="12" md="6" lg="6">
                        <h2 className="title3 mb-5"  data-aos="fade-up">Formation à distance</h2>
                      <CardImg src="/images/logo/logo-formation.png" alt="zone"/>
                      <p className="texte-formation">Formation en présentiel – formation sur site – formation en distanciel (en live)</p>
                      <p className="texte-type">Individuel – collectif – en intra</p>
                    </Col>
                </Row>
                </Container>
              </div>
              )
            }/>
          <div className="flex-grow-1 page p-0">
            <Route path="/cms/:id-:name" component={CmsPage}/>
            <Route path="/login" component={SingIn}/>
            <Route path="/registration" component={Registration}/>
            <Route path="/user" component={UserPage}/>
            <Route path="/events/:id" component={EventsPage}/>
            <Route path="/download" component={EventDownloadUser}/>
            <Route path="/addresse" component={Addresse}/>
            <Route path="/forgot-password" component={Forgotpassword}/>
            <Route path="/change-password" component={ChangePassword}/>
          </div>
          <Footer />
        </main>
      </Router>
    );
  }
}

function mapStateToProps({generalReducer}) {
  return {
    general: generalReducer,
  }
}

function mapDispatchToProps(dispatch) {
  return {
    generalActions : bindActionCreators(generalActions, dispatch),
    requestLogin   : bindActionCreators(requestLogin, dispatch),
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(Page);


// WEBPACK FOOTER //
// ./src/containers/Page/index.js